<template>
  <div class="config-detail-bu">
      <!-- <div class="title">{{assignBu.orgName}}</div>
      <el-input class="item" v-model="subAssignItem.assignQty" placeholder="请输入分配额度"></el-input> -->
      <!-- <div  v-if="buToCity===1">
        <el-form :model="subAssignItem" ref="editFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
          <el-form-item :label="assignName" prop="assignQty">
              <el-input type="number" :min="0" class="item" v-model="subAssignItem.assignQty" placeholder="请输入分配额度"  @blur="handleBlur"></el-input>
          </el-form-item>
        </el-form>
      </div> -->
      <div>
        <!-- <div class="operation-btn" v-if="(needTransitions!=0)">
          <div class="display-date" v-if="!ischangeDate">{{ assignItemInfo.assignStartTime | parseTime("{y}-{m}-{d}") }} 至 {{ assignItemInfo.assignEndTime | parseTime("{y}-{m}-{d}") }}</div>
          <el-date-picker
            v-else
            :picker-options="pickerOptions"
            v-model="value1"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleSelectDate">
          </el-date-picker>
          <div v-if="getLevelIndex===0&&isFisrtConfig" class="add-style" @click="showChangeDate()">编辑</div>
          <div v-if="getLevelIndex===0&&isFisrtConfig" class="operate-style" @click="handleDelete">删除</div>
        </div> -->
      </div>

        <div class="assign-box" >
        <el-form v-for="item of subAssignList" :model="item" :key="item.orgName" ref="editFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
          <el-form-item :label="getName(item.orgName)" prop="assignQty">
              <el-input type="number" :min="0" class="item" v-model="item.assignQty" placeholder="请输入分配额度" @change="updateSubmitData"></el-input>
          </el-form-item>
        </el-form>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props:{
    // assignList: { type: Object, default: () => {} },
    needTransitions:{type:Number,default:0},
    assignItemInfo: { type: Object, default: () => { } },
    getSubAssignList: { type: Array, default: () => [] },
    //assignList:{ type: Array, default: () => [] },
    assignBuList:{ type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    assignAreaList: { type: Array, default: () => [] },
    buToCity:{ type: Number, default: 0 },
    saveDetail:{ type: Object, default: () => { } },
    saveSubAssignList:{ type: Array, default: () => [] },
    srcAssignId:{type:String,default:'0'},
    itemKey:{type:Number,default:1},
    levelIndex:{type:String,default:'0'},
    isFisrtConfig:{type:Boolean,default:true},
    pickerOptions:{type: Object, default: () => { } },
    submitAssignList:{type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters(['userInfo']),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getLevelIndex(){
      return Number(this.levelIndex[0])
    }
  },
  watch:{
    'value1' (val,oldv) {
      if(val.length!==0){
        this.submitAssignList.forEach((item,index)=>{
          if(item.assignStartTime==val[0]&&item.assignEndTime==val[1]){
            console.log(this.itemKey);
            console.log(item)
            if(item.assignItemKey!==this.itemKey){
              this.ischangeDate = true
              this.$alert(`不能选择相同时间段的转场时间！`, '提示', {
                confirmButtonText: '确定',
                confirmButtonClass: 'btn-red',
              }).then(() => {
                this.value1 = []
                this.ischangeDate = false
              })
              return
            }
          }else {
            this.$emit("handleChangeAssignDate",val,this.itemKey)
            this.value1 = []
            this.ischangeDate = false
          }
        })
      }else {
        this.ischangeDate = false
      }
    }
  },
  data(){
    return {
      employeeLevel:'',
      assignQty:'',
      subAssignItem:{
        assignQty:''
      },
      value1:[],
      assignName:'',
      editRules:{
        // assignQty:[{ required: true, message: "请输入分配额度", trigger: "blur" }]
      },
      subAssignList:[],
      ischangeDate:false
    }
  },
  created(){
    this.employeeLevel = this.userInfo.employeeLevel
      this.subAssignList = this.getSubAssignList.map(item=>{
        let data = {
          //assignStartTime:this.assignItemInfo.assignStartTime,
          //assignEndTime:this.assignItemInfo.assignEndTime,
          needTransitions:this.needTransitions,
          orgName:item.orgName,
          itemKey:this.itemKey,
          //orgCode:item.orgCode,
          srcAssignId:this.srcAssignId
        }
        if(this.isHQ){
          data.buCode = item.orgCode
        }else if(this.isBU){
          data.regionCode = item.orgCode
        }else if(this.isRegion){
          data.areaCode = item.orgCode
        }
        let index = -1
        index = this.saveSubAssignList.findIndex(saveItem=>{
          return (saveItem.buCode&&saveItem.buCode==item.orgCode)
                ||(saveItem.regionCode&&saveItem.regionCode==item.orgCode)
                ||(saveItem.areaCode&&saveItem.areaCode==item.orgCode)
        })
        index===-1?data.assignQty='':data.assignQty=this.saveSubAssignList[index].assignQty
        return data
      })

    // this.assignName = this.assignItem.orgName.split('|')[0]
    // if(this.employeeLevel>=90&&this.saveSubAssignList){
    //   if(this.saveSubAssignList.length>0){
    //     for(let save of this.saveSubAssignList){
    //       if(save.buCode === this.assignItem.orgCode){
    //         this.subAssignItem.assignQty = save.assignQty
    //       }
    //       // for(let item of this.assignBuList){
    //       //   console.log(save.buCode);
    //       //   console.log(item.orgCode);
    //       //   if(save.buCode === item.orgCode){
    //       //     this.subAssignItem.assignQty = save.assignQty
    //       //   }
    //       // }
    //     }
    //     this.subAssignItem.buCode = this.assignItem.orgCode
    //     this.subAssignItem.srcAssignId = '0'
    //   }
    // }else if(this.saveSubAssignList){
    //   for(let save of this.saveSubAssignList){
    //     if(this.buToCity==1){
    //       if(save.regionCode == this.assignItem.parentOrgCode && save.assignLevel==='area'){
    //         if(save.areaCode === this.assignItem.orgCode){
    //           this.subAssignItem.assignQty = save.assignQty
    //           let data = {
    //             assignQty:save.assignQty,
    //             regionCode:save.regionCode,
    //             areaCode:save.areaCode,
    //             srcAssignId:save.srcAssignId
    //           }
    //           this.$emit("handleAssign",data)
    //         }
    //       }
    //     }else {
    //       if(save.regionCode === this.assignItem.orgCode && save.assignLevel==='region'){
    //         this.subAssignItem.assignQty = save.assignQty
    //         let data = {
    //           assignQty:save.assignQty,
    //           regionCode:save.regionCode,
    //           areaCode:save.areaCode,
    //           srcAssignId:save.srcAssignId
    //         }
    //         this.$emit("handleAssign",data)
    //       }else if(save.areaCode === this.assignItem.orgCode && save.assignLevel==='area'){
    //         this.subAssignItem.assignQty = save.assignQty
    //         let data = {
    //           assignQty:save.assignQty,
    //           regionCode:save.regionCode,
    //           areaCode:save.areaCode,
    //           srcAssignId:save.srcAssignId
    //         }
    //         this.$emit("handleAssign",data)
    //       }
    //     }
    //   }
    // }
  },
  mounted(){
    //console.log(this.subAssignList);
    this.$emit("handleSubmitAssign",this.subAssignList,this.itemKey)
  },
  methods:{
    showChangeDate(){
      this.ischangeDate = true
    },
    handleDelete(){
      this.$emit("handleDeleteAssign",this.itemKey)
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    submit(){
      if(this.employeeLevel>=90){
        this.subAssignItem.buCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = '0'
        this.subAssignItem.buChangeQty = this.subAssignItem.assignQty
        this.subAssignItem.itemKey = this.itemKey
      }else if(this.employeeLevel>=60&&this.employeeLevel<=90){
        if(this.buToCity==1){
          this.subAssignItem.areaCode = this.assignItem.orgCode
          this.subAssignItem.regionCode = this.assignItem.parentOrgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
        }else {
          this.subAssignItem.regionCode = this.assignItem.orgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
          this.subAssignItem.itemKey = this.itemKey
          // this.assignItem.parentOrgCode?this.subAssignItem.areaCode = this.assignItem.parentOrgCode:''
        }
      }else if(this.employeeLevel===50){
        this.subAssignItem.areaCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = this.srcAssignId
        this.subAssignItem.itemKey = this.itemKey
      }
      this.$emit("handleSubmit",this.subAssignItem)
    },
    updateSubmitData(){
      console.log(this.subAssignList);
      this.$emit("handleSubmitAssign",this.subAssignList,this.itemKey)
    },
    handleBlur(){
      if(this.employeeLevel>=60&&this.employeeLevel<90){
        if(this.buToCity==1){
          this.subAssignItem.areaCode = this.assignItem.orgCode
          this.subAssignItem.regionCode = this.assignItem.parentOrgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
        }else {
          this.subAssignItem.regionCode = this.assignItem.orgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
          // this.assignItem.parentOrgCode?this.subAssignItem.areaCode = this.assignItem.parentOrgCode:''
        }
      }else if(this.employeeLevel>=50&&this.employeeLevel<60){
        this.subAssignItem.areaCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = this.srcAssignId
      }
      console.log(this.subAssignItem);
      this.$emit("handleAssign",this.subAssignItem)
    },
    handleSelectDate(val){
      // if(val.length!==0){
      //   this.submitAssignList.forEach((item,index)=>{
      //   if(item.assignStartTime==val[0]&&item.assignEndTime==val[1]){
      //     console.log(this.itemKey);
      //     console.log(item)
      //     if(item.assignItemKey!==this.itemKey){
      //       this.ischangeDate = true
      //       this.$alert(`不能选择相同时间段的转场时间！`, '提示', {
      //         confirmButtonText: '确定',
      //         confirmButtonClass: 'btn-red',
      //       }).then(() => {
      //       })
      //       return
      //     }else {
      //       this.$emit("handleChangeAssignDate",val,this.itemKey)
      //       this.value1 = []
      //       this.ischangeDate = false
      //     }
      //   }
      // })

      //}
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus, 
.el-form-item.is-error .el-textarea__inner, 
.el-form-item.is-error .el-textarea__inner:focus, 
.el-message-box__input input.invalid, 
.el-message-box__input input.invalid:focus {
  border-color: #c7c7c7 !important;
}
::v-deep .el-form-item {
  margin: 3px 0;
  .el-form-item__label {
    text-align: left;
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}
::v-deep .operation-btn .el-input__inner {
    width: 250px !important;
}
::v-deep .assign-box .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
.config-detail-bu{
  // display: flex;
}
.bu_item{
  margin: 0 15px 0 5px;
}
::v-deep  .el-form-item {
    margin: 3px 15px 0 0px !important;
    //display: flex;
    width: 200px;
}
.warning{
  display: inline-block;
  margin-left: 10px;
  color: red;
}
.assign-box{
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
.display-date{
  text-align: left;
  width: 250px;
}
.operation-btn{
  display: flex;
  height: 30px;
  text-align: center;
  align-items: center;
  width: 350px;
  margin-top: 10px;
  justify-content: space-between;
}
.add-style{
  color: rgb(0, 145, 230);
  cursor: pointer;
}
.operate-style{
  color: rgb(238, 0, 0);
  cursor: pointer;
}
</style>